import { render, staticRenderFns } from "./handAddHost.vue?vue&type=template&id=28d07047&"
import script from "./handAddHost.vue?vue&type=script&lang=js&"
export * from "./handAddHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports